module.exports = __webpack_public_path__ + "img/Sign.a4151769.svg";